import {isMobile} from "react-device-detect";

export const mobileMode = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isIOS = /iphone|ipod|ipad|ios/.test(userAgent);
    const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);
    
    return (isMobile || isIOS || window.name === 'bookingSettingsIframe' || window.innerWidth < 600) && !isTablet;
}

export const isMobileDevice = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isIOS = /iphone|ipod|ipad|ios/.test(userAgent);
    const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);
    
    return isMobile || isTablet || isIOS;
}